import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard/authguard.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'form', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./mycomponents/home/home.component').then((m) => m.HomeComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./mycomponents/sign-in/sign-in.component').then((m) => m.SignInComponent),
  },
  {
    path: 'form',
    loadComponent: () => import('./mycomponents/form/form.component').then((m) => m.FormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'adminform',
    loadComponent: () => import('./mycomponents/form-list/form-list.component').then((m) => m.FormListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-question/:id',
    loadComponent: () =>
      import('./mycomponents/add-question/add-question.component').then((m) => m.AddQuestionComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-question-new/:id',
    loadComponent: () =>
      import('./mycomponents/add-question-new/add-question-new.component').then((m) => m.AddQuestionNewComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-question-rule/:id',
    loadComponent: () =>
      import('./mycomponents/add-question-rule/add-question-rule.component').then((m) => m.AddQuestionRuleComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'add-question-equation-rule/:id',
    loadComponent: () =>
      import('./mycomponents/add-question-equation-rule/add-question-equation-rule.component').then(
        (m) => m.AddQuestionEquationRuleComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'create',
    loadComponent: () => import('./create-form/create-form.component').then((m) => m.CreateFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-form/:id',
    loadComponent: () => import('./create-form/create-form.component').then((m) => m.CreateFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'grid',
    loadComponent: () => import('./mycomponents/ag-grid/ag-grid.component').then((m) => m.AgGridComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'fillForm/:BhaktGUID/:BhaktId',
    loadComponent: () => import('./mycomponents/question/question.component').then((m) => m.QuestionComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'fillForm',
    loadComponent: () => import('./mycomponents/question/question.component').then((m) => m.QuestionComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'instructions',
    loadComponent: () =>
      import('./mycomponents/view-form-instructions/view-form-instructions.component').then(
        (m) => m.ViewFormInstructionsComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'register-form',
    loadComponent: () =>
      import('./mycomponents/registration-form/registration-form.component').then((m) => m.RegistrationFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'viewresponse',
    loadComponent: () =>
      import('./mycomponents/viewresponse/viewresponse.component').then((m) => m.ViewresponseComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'pastpayments/:BhaktGUID',
    loadComponent: () =>
      import('./mycomponents/pasttransactions/pasttransactions.component').then((m) => m.PasttransactionsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'past-responses/:formId/:bhaktId',
    loadComponent: () =>
      import('./mycomponents/past-responses/past-responses.component').then((m) => m.PastResponsesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'pastpayments',
    loadComponent: () =>
      import('./mycomponents/pasttransactions/pasttransactions.component').then((m) => m.PasttransactionsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'paymentresult',
    loadComponent: () =>
      import('./mycomponents/paymentresult/paymentresult.component').then((m) => m.PaymentresultComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'adminpastpayments',
    loadComponent: () =>
      import('./mycomponents/adminpasttxn/adminpasttxn.component').then((m) => m.AdminpasttxnComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'chandanreport',
    loadComponent: () =>
      import('./mycomponents/chandanreport/chandanreport.component').then((m) => m.ChandanreportComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'yagna/:BhaktGUID/:BhaktId',
    loadComponent: () => import('./mycomponents/yagna/yagna.component').then((m) => m.YagnaComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'form-images/:id',
    loadComponent: () =>
      import('./mycomponents/form-images/form-images.component').then((m) => m.FormImagesComponent),
    canActivate: [AuthGuard],
  },
];
